import React from 'react';
import { Form, Select } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";

const CraftSelectTypeIconFormItem = ({
    form,
    disabled = false,
    initialValue,
    name = 'type_icon',
    label = Localize({ children: "FORMS.Input_Label_CraftTypeIcon" }).props.children,
}) => {
    const ICON_OPTIONS = [
        { value: null, label: <Localize>FORMS.Input_Placeholder_Choose</Localize>, icon: null },
        { value: 'logistics', label: 'Logistics', icon: <Icons.AdditionalCrafts.LogisticsIcon style={{ fontSize: 30 }} /> },
        { value: 'floor', label: 'Floor', icon: <Icons.AdditionalCrafts.FloorIcon style={{ fontSize: 30 }} /> },
        { value: 'assembly', label: 'Assembly', icon: <Icons.AdditionalCrafts.AssemblyIcon style={{ fontSize: 30 }} /> },
        { value: 'electrics', label: 'Electrics', icon: <Icons.AdditionalCrafts.ElectricsIcon style={{ fontSize: 30 }} /> },
        { value: 'graphic', label: 'Graphic', icon: <Icons.AdditionalCrafts.GraphicIcon style={{ fontSize: 30 }} /> },
        { value: 'furniture', label: 'Furniture', icon: <Icons.AdditionalCrafts.FurnitureIcon style={{ fontSize: 30 }} /> },
        { value: 'cleaning', label: 'Cleaning', icon: <Icons.AdditionalCrafts.CleaningIcon style={{ fontSize: 30 }} /> },
        { value: 'mp_control', label: 'MP Control', icon: <Icons.AdditionalCrafts.MpControlIcon style={{ fontSize: 30 }} /> },
        { value: 'protocol', label: 'Protocol', icon: <Icons.AdditionalCrafts.ProtocolIcon style={{ fontSize: 30 }} /> },
        { value: 'faucet', label: 'Wasseranschluss', icon: <Icons.AdditionalCrafts.FaucetIcon style={{ fontSize: 30 }} /> },
        { value: 'plug', label: 'Hallenelektriker', icon: <Icons.AdditionalCrafts.PlugIcon style={{ fontSize: 30 }} /> },
    ];

    return (
        <Form.Item
            name={name}
            label={label}
            initialValue={initialValue}
        >
            <Select
                showSearch
                showArrow
                suffixIcon={<Icons.Arrow />}
                className="select-serch-input"
                disabled={disabled}
                placeholder={Localize({ children: "FORMS.Input_Placeholder_Choose" }).props.children}
                dropdownClassName="select-serch-dropdown craft-select"
                optionFilterProp="value"
                value={form ? form.getFieldValue(name) : undefined}
                onChange={value => form && form.setFieldsValue({ type_icon: value === undefined ? null : value })}
            >
                {ICON_OPTIONS.map(({ value, label, icon }) => (
                    <Select.Option key={String(value)} value={value}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>{icon}<span style={{ marginLeft: 8 }}>{label}</span></span>
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default CraftSelectTypeIconFormItem;